import React from "react";
import { SpinnerLoader } from "../../../common/loader";
import "./index.m.css";
import { FailureIconInner, FailureCircleOuter, FailureCircleMiddle, RetryIcon } from "./icons";
import Whatsapp from "../../../atoms/social-media-icons/Whatsapp";
import Mail from "../../../atoms/social-media-icons/Mail";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";

export const FailurePage = ({ onRetry, onReview, onReturnHome, isPaymentProcessing }) => {

  return (
    <div styleName="failurePageContainer">
      {isPaymentProcessing && (
        <div styleName="overlayLoader">
          <SpinnerLoader />
        </div>
      )}
      <div styleName="contentArea">
        <div styleName="clipWrapper">
          <div styleName="ringsBackground">
            <FailureCircleOuter styleName="outerCircle" />
            <FailureCircleMiddle styleName="middleCircle" />
          </div>
        </div>

        <div styleName="contentWrapper">
          <FailureIconInner styleName="innerIcon" />
          <h1 styleName="title">{SUBSCRIBE_PAGE_TEXT.FAILURE_TITLE}</h1>
          <p styleName="message">
            {SUBSCRIBE_PAGE_TEXT.FAILURE_MSG}
          </p>

          <div styleName="buttonGroup">
            <button styleName="primaryButton" onClick={onRetry}>
              <RetryIcon styleName="buttonIcon" />
              {SUBSCRIBE_PAGE_TEXT.RETRY_CTA}
            </button>
            <button styleName="secondaryButton" onClick={onReview}>
              {SUBSCRIBE_PAGE_TEXT.REVIEW_CTA}
            </button>
          </div>

          <button styleName="returnLink" onClick={onReturnHome || (() => { if (typeof window !== "undefined") window.location.href = "/"; })}>
            {SUBSCRIBE_PAGE_TEXT.RETURN_LINK}
          </button>

          <div styleName="contactSection">
            <div styleName="contactHeader">
              <span styleName="contactTextRegular">{SUBSCRIBE_PAGE_TEXT.CONTACT_PREFIX}</span>
              <span styleName="contactTextBold">{SUBSCRIBE_PAGE_TEXT.CONTACT_SUFFIX}</span>
            </div>

            <a
              href="https://api.whatsapp.com/send/?phone=919035267304&text=Hi%2C%20I%20need%20assistance%20with%20my%20Prajavani%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0"
              styleName="contactButton whatsappBtn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Whatsapp width={18} height={18} color="#25D366" />
              <span>+91 9035267304</span>
            </a>

            <a
              href="https://mail.google.com/mail/u/0/?fs=1&to=support@prajavani.net&su=Support+Required+for+PV+subscription&body=Hi%2C+I+need+assistance+with+my+Prajavani+Premium+Subscription.+Could+you+please+help+me%3F&tf=cm"
              styleName="contactButton mailBtn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Mail width={16} height={13} color="#999" />
              <span>support@prajavani.net</span>
            </a>

            <div styleName="timingTitle">{SUBSCRIBE_PAGE_TEXT.TIMING_TITLE}</div>
            <div styleName="timingText">{SUBSCRIBE_PAGE_TEXT.TIMING_TEXT}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
